// notify_sound_v1: เสียงเตือนข้อความใหม่ — สังเคราะห์ด้วย WebAudio (ไม่ต้องมีไฟล์เสียง)
// เก็บการตั้งค่าใน localStorage (ต่อผู้ใช้/ต่อ browser) ให้แต่ละคนเปิด/ปิด + เลือกเสียงเองได้
let _ctx = null;
function ctx() {
  try {
    if (!_ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      _ctx = new AC();
    }
    if (_ctx.state === 'suspended') { _ctx.resume().catch(() => {}); }
    return _ctx;
  } catch (e) { return null; }
}

// ปลดล็อกเสียง (เบราว์เซอร์บล็อก autoplay จนกว่าจะมี user gesture) — เรียกตอนคลิกปุ่ม
export function unlockAudio() {
  const c = ctx();
  if (c && c.state === 'suspended') { c.resume().catch(() => {}); }
}

// preset: notes = [ [freq, startOffsetSec, durSec], ... ]
const PRESETS = {
  ding:  { label: '🔔 กริ๊ง',  type: 'sine',     notes: [[880, 0, 0.12], [1320, 0.10, 0.24]] },
  chime: { label: '🎵 ระฆัง',  type: 'sine',     notes: [[659, 0, 0.14], [784, 0.13, 0.14], [988, 0.26, 0.30]] },
  beep:  { label: '📟 บี๊บ',   type: 'square',   notes: [[1000, 0, 0.09], [1000, 0.15, 0.11]] },
  ping:  { label: '💧 ปิ๋ง',   type: 'triangle', notes: [[1245, 0, 0.20]] },
  pop:   { label: '🫧 ป๊อป',   type: 'sine',     notes: [[520, 0, 0.05], [920, 0.05, 0.13]] },
};

export const SOUND_OPTIONS = Object.keys(PRESETS).map(k => ({ value: k, label: PRESETS[k].label }));

export function playNotifySound(name = 'ding', volume = 0.6) {
  const c = ctx();
  if (!c) return;
  const p = PRESETS[name] || PRESETS.ding;
  const vol = Math.max(0, Math.min(1, Number(volume)));
  if (vol <= 0) return;
  const now = c.currentTime;
  p.notes.forEach(([freq, off, dur]) => {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = p.type;
    osc.frequency.value = freq;
    const t0 = now + off;
    // envelope กันเสียง click ตอนเริ่ม/จบ
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(vol, t0 + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    osc.connect(g); g.connect(c.destination);
    osc.start(t0); osc.stop(t0 + dur + 0.03);
  });
}

const K = 'notify_sound_v1';
export function getSoundSettings() {
  try {
    const s = JSON.parse(localStorage.getItem(K) || '{}');
    return {
      enabled: s.enabled !== false,                                   // default เปิด
      sound: (s.sound && PRESETS[s.sound]) ? s.sound : 'ding',
      volume: typeof s.volume === 'number' ? Math.max(0, Math.min(1, s.volume)) : 0.6,
      desktop: s.desktop === true,                                    // notify_desktop_v1: default ปิด (ต้องขอสิทธิ์ก่อน)
    };
  } catch (e) {
    return { enabled: true, sound: 'ding', volume: 0.6, desktop: false };
  }
}
export function setSoundSettings(patch) {
  const next = { ...getSoundSettings(), ...patch };
  try { localStorage.setItem(K, JSON.stringify(next)); } catch (e) {}
  return next;
}

// notify_desktop_v1: แจ้งเตือนหน้าจอ (Web Notifications API) — เด้งมุมจอตอนสลับแท็บ
export function notifySupported() {
  return typeof window !== 'undefined' && 'Notification' in window;
}
export function notifyPermission() {
  return notifySupported() ? Notification.permission : 'unsupported';
}
export function requestNotifyPermission() {
  if (!notifySupported()) return Promise.resolve('unsupported');
  try {
    return Notification.requestPermission().then(p => p).catch(() => 'denied');
  } catch (e) {
    // Safari รุ่นเก่าใช้ callback style
    return new Promise(res => { try { Notification.requestPermission(res); } catch (e2) { res('denied'); } });
  }
}
export function showDesktopNotification({ title, body, icon, tag, onClick } = {}) {
  if (!notifySupported() || Notification.permission !== 'granted') return null;
  try {
    const n = new Notification(title || 'ข้อความใหม่', {
      body: body || '',
      icon: (icon && /^https?:\/\//.test(icon)) ? icon : undefined,
      tag: tag || undefined,      // tag เดียวกัน = แทนที่ของเดิม (ไม่กองซ้อน)
      renotify: false,
    });
    n.onclick = () => { try { window.focus(); } catch (e) {} if (typeof onClick === 'function') { try { onClick(); } catch (e) {} } n.close(); };
    setTimeout(() => { try { n.close(); } catch (e) {} }, 8000); // ปิดเองใน 8 วิ
    return n;
  } catch (e) { return null; }
}
